(function(){
  if (window.__nestAdaScannerRemediation20260901b) return;
  window.__nestAdaScannerRemediation20260901b = 'v3-overflow-aware-scroll-region';

  function clean(text) {
    return String(text || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    if (!el || !el.getClientRects || !el.getClientRects().length) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function fixReviewLinkNames(root) {
    var links = (root || document).querySelectorAll('[data-nest-pdp-review-link-a11y][role="link"]');
    Array.prototype.forEach.call(links, function(link) {
      link.removeAttribute('aria-label');
    });
  }

  function fixYotpoTabs(root) {
    var navs = (root || document).querySelectorAll('.yotpo-nav[role="tablist"]');
    Array.prototype.forEach.call(navs, function(nav) {
      var tabs = Array.prototype.slice.call(nav.querySelectorAll('.yotpo-nav-tab, [role="tab"]'))
        .filter(function(tab) { return isVisible(tab) && /reviews|questions/i.test(clean(tab.textContent)); });
      var tablist = nav.querySelector('ul') || nav.querySelector('[role="list"]');

      nav.removeAttribute('role');
      if (nav.getAttribute('aria-label') === 'Product reviews and questions') {
        nav.removeAttribute('aria-label');
      }

      if (tabs.length < 2 || !tablist) return;
      tablist.setAttribute('role', 'tablist');
      if (!tablist.getAttribute('aria-label')) tablist.setAttribute('aria-label', 'Product reviews and questions');
      tabs.forEach(function(tab, index) {
        var selected = tab.classList.contains('yotpo-active') || tab.getAttribute('aria-selected') === 'true';
        if (!tab.id) tab.id = 'nest-yotpo-tab-ada-' + index;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('tabindex', '0');
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    });
  }

  function fixHeaderLandmarks(root) {
    var headerWrapper = document.querySelector('#shopify-section-header');
    var stickyHeader = document.querySelector('body > .sticky-header-content');
    var header = document.querySelector('header.site-header');

    if (stickyHeader) {
      stickyHeader.setAttribute('role', 'banner');
      stickyHeader.setAttribute('aria-label', 'Site header');
    }
    if (headerWrapper && headerWrapper !== stickyHeader) {
      headerWrapper.removeAttribute('role');
      headerWrapper.removeAttribute('aria-label');
    }
    if (header) {
      header.setAttribute('role', 'presentation');
      header.removeAttribute('aria-label');
    }
  }

  function fixTables(root) {
    var tables = (root || document).querySelectorAll('table');
    Array.prototype.forEach.call(tables, function(table) {
      Array.prototype.forEach.call(table.querySelectorAll('tr'), function(row) {
        var firstCell = row.children && row.children[0];
        if (firstCell && firstCell.tagName === 'TH' && !clean(firstCell.textContent)) {
          firstCell.innerHTML = '<span class="visually-hidden">Feature</span>';
        }
      });

      Array.prototype.forEach.call(table.querySelectorAll('tr:first-child th'), function(th) {
        if (!th.getAttribute('scope')) th.setAttribute('scope', 'col');
      });
      Array.prototype.forEach.call(table.querySelectorAll('tr th:first-child'), function(th) {
        if (!th.getAttribute('scope')) th.setAttribute('scope', 'row');
      });
    });
  }

  function fixScrollableRegions(root) {
    var selectors = '.inner-product-table, .comparison-competitors';
    Array.prototype.forEach.call((root || document).querySelectorAll(selectors), function(el) {
      var overflows = el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1;
      var helperLabel = el.getAttribute('aria-label') === 'Scrollable product comparison';

      if (overflows) {
        el.setAttribute('tabindex', '0');
        if (!el.getAttribute('role')) el.setAttribute('role', 'region');
        if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Scrollable product comparison');
        el.setAttribute('data-nest-scroll-region-a11y', 'true');
        return;
      }

      if (el.getAttribute('data-nest-scroll-region-a11y') === 'true' || helperLabel) {
        if (el.getAttribute('tabindex') === '0') el.removeAttribute('tabindex');
        if (helperLabel) el.removeAttribute('aria-label');
        if (el.getAttribute('role') === 'region' && el.getAttribute('data-nest-scroll-region-a11y') === 'true') {
          el.removeAttribute('role');
        }
        el.removeAttribute('data-nest-scroll-region-a11y');
      }
    });
  }

  function apply(root) {
    fixReviewLinkNames(root);
    fixYotpoTabs(root);
    fixHeaderLandmarks(root);
    fixTables(root);
    fixScrollableRegions(root);
  }

  function schedule(root) {
    window.clearTimeout(schedule.timer);
    schedule.timer = window.setTimeout(function(){ apply(root || document); }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ apply(document); }, { once: true });
  } else {
    apply(document);
  }

  [250, 800, 1800, 3500, 6000].forEach(function(delay) {
    window.setTimeout(function(){ apply(document); }, delay);
  });

  if (window.MutationObserver && document.body) {
    new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          schedule(document);
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
